import React, { memo } from 'react'

import { LIBRARY_FILTER } from 'Pods/ThreeDStudio/Store/constants'

import FilteringCheckbox from './Components/FilteringCheckbox/FilteringCheckbox'
import GeneratedSubItems from './Components/GeneratedSubItems/GeneratedSubItems'

function FilteringContent() {
  return (
    <div className="filtering-content">
      <FilteringCheckbox
        keyName="generated"
        id="filtering-content-generated"
        label="Generated"
      />
      <GeneratedSubItems />
      <FilteringCheckbox
        keyName={LIBRARY_FILTER.PURCHASED}
        id="filtering-content-purchased"
        label="Purchased"
      />
      <FilteringCheckbox
        keyName={LIBRARY_FILTER.UPLOADED}
        id="filtering-content-uploaded"
        label="Uploaded"
      />
    </div>
  )
}

export default memo(FilteringContent)
